export const ENTITY_NATURE_OPTIONS = [
  "Financial Entity (Parent Undertaking)",
  "Financial Entity (Subsidiary)",
  "Branch",
  "Financial Entity (Standalone)",
  "Financial Entity (Sub-consolidated)",
  "Financial Entity (Consolidated)"
] as const;

export type EntityNature = typeof ENTITY_NATURE_OPTIONS[number];